// import node module libraries
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { Fragment, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Row, Col, Image, Dropdown, ListGroup, Button } from "react-bootstrap";
import Avatar from "@mui/material/Avatar";

// simple bar scrolling used for notification item scrolling
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";

// import custom components
import DotBadge from "components/docs/bs-components/DotBadge";
import DarkLightMode from "layouts/DarkLightMode";
import GKTippy from "components/elements/tooltips/GKTippy";

// import media files
import Avatar1 from "assets/images/avatar/avatar-1.jpg";

// import data files
// import NotificationList from 'data/Notification';
import { useCookies } from "react-cookie";
import { useEffect } from "react";
import { fetchNotification, updateUserPassword } from "ServerAPI/serverAPI";
import { useMsal } from "@azure/msal-react";
import NotificationsIcon from "@mui/icons-material/Notifications";
import CommonDialog from "components/Dialog/CommonDialog";
import UpdatePassword from "components/users/UpdatePassword";
import { useToast } from "context/toast-context/ToastProvider";

const QuickMenu = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies();
  const [NotificationList, setNotificationList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const isDesktop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const [showUpdatePasswordModal, setShowUpdatePasswordModal] = useState(false);
  const [passwordUpdateLoading, setPasswordUpdateLoading] = useState(false);
  const [passwordData, setPasswordData] = useState({
    password: "",
    confirmPassword: "",
  });
  const { showToast } = useToast();
  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((pre) => {
      return {
        ...pre,
        [name]: value,
      };
    });
  };
  const handleLogout = async () => {
    if (cookies?.userManagement === "Azure SSO") {
      instance.logout();
    }
    Object.keys(cookies).forEach((cookieName) => {
      removeCookie(cookieName);
    });

    navigate("/");
    window.location.reload();
  };
  const getNotifications = async () => {
    const result = await fetchNotification(cookies?.email, cookies?.userId);
    if (result.status === 200) {
      setNotificationList(result?.data);
    }
  };

  useEffect(() => {
    getNotifications();
  }, []);
  const closeUpdatePasswordModal = () => {
    setShowUpdatePasswordModal(false);
  };

  const handleUpdatePassword = async () => {
    setPasswordUpdateLoading(true);
    if (passwordData.password === "" || passwordData.confirmPassword === "") {
      showToast("Each fields are required", "error");
      return;
    }
    if (passwordData.password !== passwordData.confirmPassword) {
      showToast("password and confirm password should be same", "error");
      return;
    }
    const payload = {
      password: passwordData?.password,
      userId: cookies?.userId,
    };

    const response = await updateUserPassword(payload);
    setPasswordUpdateLoading(false);

    if (response.status === 200) {
      showToast("password updated successfully", "success");
      closeUpdatePasswordModal();
    } else {
      showToast("password update failed", "error");
    }
  };

  const Notifications = () => {
    return (
      <SimpleBar style={{ maxHeight: "300px", cursor: "none" }}>
        <ListGroup variant="flush">
          {NotificationList.map(function (item, index) {
            return (
              <ListGroup.Item
                className={index === 0 ? "bg-light" : ""}
                key={index}
                style={{ cursor: "none" }}
              >
                <Row className="cursor-none">
                  <Col>
                    <Link
                      className="text-body "
                      to="#"
                      style={{ cursor: "default" }}
                    >
                      <div className="">
                        <div className=" d-flex  p-2 align-items-center rounded-2 cursor-none ">
                          <p className=" text-dark ">{item.notification}</p>
                        </div>
                      </div>
                    </Link>
                  </Col>
                </Row>
              </ListGroup.Item>
            );
          })}
        </ListGroup>
      </SimpleBar>
    );
  };
  return (
    <Fragment>
      {/* <DarkLightMode /> */}
      <ListGroup
        as="ul"
        bsPrefix="navbar-nav"
        className="navbar-right-wrap ms-2 d-flex nav-top-wrap"
      >
        <Dropdown as="li">
          <Dropdown.Toggle
            as="a"
            bsPrefix=" "
            className="text-dark icon-notifications me-lg-1  btn btn-light btn-icon rounded-circle  indicator-primary text-muted"
            id="dropdownNotification"
          >
            <NotificationsIcon sx={{ color: "#171717" }} />
            <span
              className="fw-bold fs-5"
              style={{
                color: "#224b99",
                position: "absolute",
                top: "-10px",
                right: "5px",
              }}
            >
              {NotificationList.length}
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu
            show={isDesktop ? true : false}
            className="dashboard-dropdown notifications-dropdown dropdown-menu-lg dropdown-menu-end mt-3 py-0"
            aria-labelledby="dropdownNotification"
            align="end"
          >
            <div className="border-bottom px-3 pt-3 pb-3 d-flex justify-content-between align-items-end">
              <span className="h4 mb-0">Notifications</span>
            </div>
            <Notifications />
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown as="li" className="ms-1 ">
          <Dropdown.Toggle
            as="a"
            bsPrefix=" "
            className="rounded-circle "
            id="dropdownUser"
          >
            <div className="avatar avatar-md avatar-indicators">
              <Avatar alt={"User"} src={""}>
                {cookies.name[0].toUpperCase()}
              </Avatar>
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu
            show={isDesktop ? true : false}
            className="dashboard-dropdown dropdown-menu-end mt-4 py-0"
            aria-labelledby="dropdownUser"
            align="end"
          >
            <Dropdown.Item className="mt-3" style={{ cursor: "auto" }}>
              <div className="d-flex">
                <div className="lh-1">
                  <h5 className="">{cookies.name}</h5>

                  {/* <p className="mb-0 text-muted">{cookies?.roleName}</p>
                  <p className="mb-0 text-muted mt-2">{cookies.email}</p> */}
                </div>
              </div>
            </Dropdown.Item>
            <Dropdown.Item className="mt-2">
              <div className="d-flex">
                <div className="lh-1">
                  {cookies?.userManagement !== "Self Managed" ? null : (
                    <>
                      <h5
                        className="mb-1 cursor-pointer text-primary"
                        onClick={() => {
                          setShowUpdatePasswordModal(true);
                        }}
                      >
                        Update Password
                      </h5>
                    </>
                  )}
                </div>
              </div>
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item className="mb-3" onClick={handleLogout}>
              <i className="fe fe-power me-2"></i> Sign Out
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </ListGroup>

      {/* dialog for update password */}
      <CommonDialog
        open={showUpdatePasswordModal}
        handleDialogCLose={closeUpdatePasswordModal}
        handleSaveOperation={handleUpdatePassword}
        content={<UpdatePassword handleChange={handlePasswordChange} />}
        saveBtnText="Update"
        isSaveBtnLoading={passwordUpdateLoading}
        headerText="Update Password"
      />
    </Fragment>
  );
};

export default QuickMenu;
